export const sortDepositsByExpirationDate = (ids, deposits) => {
    return ids.sort(function (prev, next) {
      let dateA, dateB;
      if (!deposits.getIn([prev, 'closestExpirationDate'])) {
        dateA = new Date('9999-12-31');
      } else {
        dateA = new Date(deposits.getIn([prev, 'closestExpirationDate']))
      }
      if (!deposits.getIn([next, 'closestExpirationDate'])) {
        dateB = new Date('9999-12-31')
      } else {
        dateB = new Date(deposits.getIn([next, 'closestExpirationDate']))
      }
      return dateA.getTime() - dateB.getTime()
    });
  }

  export const filterDeposits = (immSortedDeposits, immDeposits, offersData, isCurrentlyOpenView) => {
    return immSortedDeposits.filter((id) => {
      const deposit = immDeposits.getIn(['byId', id]);
      const isClosed = deposit.get('isClosed');
      const contractNumber = deposit.getIn(['contract', 'contractNumber']);
      const offerData = offersData && offersData[contractNumber];
      return isCurrentlyOpenView
            ? !isClosed || offerData
            : isClosed && !offerData
    });
  }